import React, { createContext } from 'react';
import { getExtraPageFields } from '../helpers/api/getExtraPageFields.js';
import { getSiteConfig } from '../helpers/api/siteConfig.js'

const GlobalContext = createContext();
export default GlobalContext;

/* Builds the [{key, value}] option list */
const getPropertyOptions = (property) => (property?.items || []).map(({
    key, value
}) => ({
    key, value
}));

export const setDefaults = () => {
    return {
        siteConfig: {
            siteName: "@PwC",
            quote: {
                label: "",
                text: "",
                author: ""
            },
            featuredBanner: {
                link: "",
                text: ""
            },
            configOptions: []
        },
        categories: [],
        los: [],
        locations: []
    };
};

export const getConfig = async ({ logout }) => {
    try {
        const siteConfig = await getSiteConfig({ logout });
        const extraPageFields = await getExtraPageFields({ logout });
        const mainCategoryProperty = extraPageFields.properties?.find(property => property.mainCategory);
        const losProperty = extraPageFields.properties?.find(property => property.id === "los");
        const locationProperty = extraPageFields.properties?.find(property => property.id === "location");

        return {
            siteConfig,
            extraPageFields,
            categories: getPropertyOptions(mainCategoryProperty),
            los: [
                { key: "all", value: "All", ignoreFilter: true },
                ...getPropertyOptions(losProperty)
            ].reduce((accumulator, item) => {
                /* Keep the first occurrence, so our "show everything" wins over the plain "all" item in config.json if present. */
                return accumulator.some(({ key }) => key === item.key) ? accumulator : accumulator.concat(item);
            }, []),
            locations: getPropertyOptions(locationProperty),
            date: new Date()
        };
    }
    catch (error) {
        console.error(`Error getting site config: ${error}`);
        return null;
    }
};
